export default __webpack_public_path__ + "static/media/learn-voc.d97acea1.jpg";